<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      icon="mdi-diamond-stone"
      title="Why Us ?"
    />

    <v-container>
      <v-row>
        <v-col v-for="card in cards" :key="card.title" cols="12" md="4">
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionAboutOurProduct",

  data: () => ({
    cards: [
      {
        title: "Grow your Revenue",
        subtitle: "Best Productivity",
        text:
          "Access real-time data that delivers insights to transform your business.",
        callout: "01",
      },
      {
        title: "Improve Quality",
        subtitle: "Special Offers",
        text:
          "Move your freight with a carrier network 15% safer than the industry average.",
        callout: "02",
      },
      {
        title: "Save Money, Save Time",
        subtitle: "Income Flow",
        text:
          "As cargo volumes grow, our network becomes more efficient, lowering your total cost to ship.",
        callout: "03",
      },
    ],
  }),
};
</script>
